import React, {Component} from 'react';
import EpicMenu from '../Menus/EpicMenu';
import '../styles.css'
import Zona from './zona';
import NuevaZona from './nuevaZona';
import { Dropdown, Icon, Modal } from 'semantic-ui-react';
import FormStyles from '../forms/form.module.css';
import Styles from './pZonas.module.css';
import {getCompanyCollection} from '../../firebase';

class Pagina extends Component{
	constructor(props){
		super(props);
		this.database = null;
		this.state = {
			actividades: [],
			useModal: false,
			view: 'table',
		}
	}

	async componentDidMount(){
		this.database = await getCompanyCollection('Zonas');
		this.unsubscribe = this.database.onSnapshot(querySnapshot =>{
			const actividades = [];
			querySnapshot.forEach(doc=>{
				const fecha = doc.data().fecha;
				actividades.push({
				id: doc.id,
				fecha: fecha && typeof fecha.toDate === 'function' ? fecha.toDate().toLocaleDateString() : '',
				variedad: doc.data().variedad,
				sector: doc.data().sector,
				estado: doc.data().estado,
				tuneles: Array.isArray(doc.data().tuneles) ? doc.data().tuneles : [],
				})
			})
			this.setState({actividades});
		})
	}

	componentWillUnmount(){
		if (this.unsubscribe) this.unsubscribe();
	}

	cambiarEstado=(id, estado)=>{
		if (estado === 'Activa'){
			this.database.doc(id).update({ estado: "Inactiva", });
		}
		else {
			this.database.doc(id).update({ estado: "Activa", });
		};
	}

	newZona = actividad => {
		return this.database.add({
			fecha: actividad.fecha,
			variedad: actividad.variedad,
			sector: actividad.sector,
			tuneles: actividad.tuneles,
			estado: 'Activa',
		})
	}
	modalAgregar = () => (
		<Modal 
			className={FormStyles.modal}
			onClose={() => this.changeUsModal(false)}
			onOpen={() => this.changeUsModal(true)}
			open={this.state.useModal}
			trigger={<button><Icon name='plus' />Nuevo Sector</button>}>
			<Modal.Header>Agregar Sector Nuevo</Modal.Header>
			<Modal.Content>
				<NuevaZona zonas={this.state.actividades} newZona={this.newZona} changeModal={this.changeUsModal} />
			</Modal.Content>
		</Modal>
	)
	changeUsModal=(open)=>{
		this.setState({useModal:open})
	}
	handleViewChange = (event, {value}) => {
		this.setState({view: value})
	}
	render(){
		const sectores = [...this.state.actividades].sort((previous, current) =>
			String(previous.sector || '').localeCompare(String(current.sector || ''), undefined, {numeric: true})
		)
		return (
		<div>
			<div className='header'>
				<EpicMenu />
				<div className='inline'>Sectores</div>
				<div className="addNew" ><this.modalAgregar /></div>
			</div>
			<div className={Styles.viewToolbar}>
				<label htmlFor='zonesView'>Vista:</label>
				<Dropdown
					id='zonesView'
					selection
					compact
					value={this.state.view}
					onChange={this.handleViewChange}
					options={[
						{key: 'table', value: 'table', text: 'Tabla'},
						{key: 'map', value: 'map', text: 'Mapa'},
					]}
				/>
			</div>
			<div className='body zonasTableContainer'>
			{this.state.view === 'table' ?
				<div className="tabla">
				<table><tbody>
				<tr>
					<th>Sector</th>
					<th>Variedad</th>
					<th>Tuneles</th>
				</tr>
				{
					sectores.map((actividad) => {
						return (
							<tr key={actividad.id}><Zona  
								fecha={actividad.fecha}
								variedad={actividad.variedad}
								sector={actividad.sector}
								tuneles={actividad.tuneles}
								estado={actividad.estado}
								actID={actividad.id} 
								key={actividad.id} 
								cambiarEstado ={this.cambiarEstado}
							/></tr>
						)
					})
				}
				</tbody></table>
				</div>
				:
				<div className={Styles.mapGrid}>
					{sectores.map(actividad =>
						<section className={Styles.sectorCard} key={actividad.id}>
							<div className={Styles.sectorHeader}>
								<div>
									<span>Sector</span>
									<strong>{actividad.sector}</strong>
								</div>
								<span className={Styles.variety}>{actividad.variedad || 'Sin variedad'}</span>
							</div>
							<div className={Styles.tunnelGrid}>
								{actividad.tuneles.length > 0 ? actividad.tuneles.map((tunel, index) =>
									<div className={Styles.tunnel} key={index} title={`Túnel ${index + 1}: ${tunel} m`}>
										<span>T{index + 1}</span>
										<strong>{tunel} m</strong>
									</div>
								) : <div className={Styles.emptySector}>Sin túneles registrados</div>}
							</div>
						</section>
					)}
				</div>
			}
			</div>
			<div className="footer" >
				<div className="footer1" ></div>
				<div className="footer2" ></div>
			</div>
		</div>
		);
	}
}

export default Pagina;
